<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="emptyScreen" *ngIf="talentpools?.length == 0 && !talentpoolname && !showLoader">
    <div class="createFirstTalenpool">
        <div class="text-center">
          <div class="text-center mb-3"><img src="../../../assets/images/bacgroundvectore-2.png" alt="" style="width: 110px;"></div>
          <p class="f-16 font-weight-600 text-center">Create Your first Talentpool</p>
          <button data-testid="auto-app-talentpool-list-button-1" class="btn-trms-medium" (click)="createTalentpool()">+ Talent pool</button>
        </div>
    </div>
    <div>
      <div class="col-md-6 mx-auto d-flex">
          <div class="text-9696 f-14">
            <p>Get rid of spreadsheets. Perform CRM and track candidates on a simple cloud based platform.
            </p>
              <p>  Group candidates into different lists. If you wish to share candidates, download these lists as excel.</p>
          </div>
          <div>
            <img src="../../../assets/images/bacgroundvectore-3.png" alt="" style="width: 280px;">
          </div>
      </div>
    </div>
</div>
<!-- <div>
  <button data-testid="auto-app-talentpool-list-button-2" class="btn-trms-small">No</button>
  <button data-testid="auto-app-talentpool-list-button-3" class="btn-trms-small">
    <div class="spinner-border text-white spinner-size" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </button>
  <button data-testid="auto-app-talentpool-list-button-4" class="btn-trms-medium">+ Candidates</button>
  <button data-testid="auto-app-talentpool-list-button-5" class="btn-trms-light">Canidates List</button>
  <button data-testid="auto-app-talentpool-list-button-6" class="btn-trms-white">Yes</button>
  <button data-testid="auto-app-talentpool-list-button-7" class="btn-trms-white">Cancel</button>
</div> -->
<div class="mb-3px mb-2 talenpool-sticky-header" *ngIf="((talentpools?.length != 0 || talentpoolname) && !showLoader) && !hideTalenpooltSearchSection">
  <div class="col wccard py-2 px-3 d-flex justify-content-between  card-bottom-space">

    <div class="d-flex align-items-center">
      <div class="mr-4 py-2">
        <label class="wc-checkbox mr-2 mb-2 d-flex">
          <input data-testid="auto-app-talentpool-list-input-1" type="checkbox" [(ngModel)]="selected" (change)="selectAll(selected)" id="mycheck" name="mycheck"
            class="mr-2">
          <i class="fas fa-check"></i>All
        </label>
      </div>
      <div class="py-2 talentpool-search position-relative">
        <input data-testid="auto-app-talentpool-list-input-2" type="text" class="wc-form-control nobg" [(ngModel)]="talentpoolname"
          (input)="searchtalentpools($event)" />
        <i class="fas fa-search"></i>
        <div *ngIf="showSearchLoader" class="spinner-border position-absolute text-black" style="top:4px; right: 4px; background-color: #fff;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="mx-1">
        <span class="dropdown ats-dropBtn mx-1">
          <button data-testid="auto-app-talentpool-list-button-8" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
            appDropdownToggle aria-haspopup="true" aria-expanded="false">
            <i class="far fa-sort-alt isActive mr-2"></i>Sort By
          </button>
          <div class="dropdown-menu" aria-labelledby="userDropdownButton">
            <a data-testid="auto-app-talentpool-list-a-1" class="dropdown-item f-14" routerLinkActive="active"
              (click)="sorttalenpoolList('nameasc')">Alphabetically: A-Z</a>
            <a data-testid="auto-app-talentpool-list-a-2" class="dropdown-item f-14" routerLinkActive="active"
              (click)="sorttalenpoolList('namedesc')">Alphabetically: Z-A</a>
            <a data-testid="auto-app-talentpool-list-a-3" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('createdonasc')">Created on: Oldest to Newest</a>
            <a data-testid="auto-app-talentpool-list-a-4" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('createdondesc')">Created On: Newest to Oldest</a>
            <a data-testid="auto-app-talentpool-list-a-5" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('updatedonasc')">Last Updated On: Oldest to Recent</a>
            <a data-testid="auto-app-talentpool-list-a-6" class="dropdown-item f-14" routerLinkActive="active" (click)="sorttalenpoolList('updatedondesc')">Last Updated On: Recent to Oldest</a>
          </div>
        </span>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <!-- bulk sharing talentpools -->
      <span class="ats-cta-btn mr-2" *ngIf="selectedtalentpools?.length > 0" (click)="triggerTalentpoolSharing(null, true)" matTooltip="Share Talent Pool" [matTooltipClass]="{ 'red-tooltip': true }"  matTooltipPosition="left">
        <i class="fa-solid fa-share-nodes"></i>
      </span>
      <span class="ats-cta-btn mr-2" *ngIf="selectedtalentpools?.length > 0" matTooltip="Delete Talent Pool" [matTooltipClass]="{ 'big-tooltip': true }"  matTooltipPosition="above"> <i class="fas fa-trash"
          (click)="deleteTalentpoolConfirmation()"></i>
      </span>
      <button data-testid="auto-app-talentpool-list-button-9" class="btn-trms-medium" (click)="createTalentpool()">+ Talent pool</button>
    </div>
  </div>
</div>
<div class="d-flex headerRow align-items-center">
    <div class="" *ngFor="let header of talentpoolHeaders" [ngClass]="header == 'Talentpool Name' ? 'col-4': header == 'Actions' ? 'col-2' : 'col'">
      <span *ngIf="header == 'Recommended Matches'" class="gen-ai-text"><i class="fa-solid fa-stars mr-1"></i></span>{{header}}
    </div>
  </div>
<div class="data-card pt-0" *ngIf="talentpools?.length != 0 && !showLoader" style="overflow: hidden;     border-top-left-radius: 0;border-top-right-radius: 0; margin-top: -1px;">
  <div>
   <div class="d-flex datarow align-items-center" *ngFor="let talent of talentpools">
    <div class="col-4">
      <div class="d-flex">
        <label class="wc-checkbox mr-2 mb-0 d-flex">
          <input data-testid="auto-app-talentpool-list-input-3" type="checkbox" id="mycheck" name="mycheck" [checked]="talent.selected" [(ngModel)]="talent.selected" (change)="checkIfAllSelected(talent,talent?.selected)">
            <i class="fas fa-check"></i>
        </label>
        <div (click)="OpenCandidateList(talent);">
          <span class="mb-2 pointer" [matTooltip]="talent?.name | titlecase" [matTooltipClass]="{ 'big-tooltip': true }"  matTooltipPosition="above">{{talent?.name |titlecase}}</span>
          <p class="mb-0 mt-2" style="color: #B3B3B3;"><i class="fa-regular fa-user mr-3"></i>{{talent?.firstname}} {{talent?.lastname}}</p>
        </div>
      </div>

    </div>
    <div class="col" (click)="OpenCandidateList(talent);">
       <p class="mb-0 pointer">{{talent?.candidatecount}}</p>
    </div>
    <div class="col">
      <p class="mb-2 d-flex align-items-center pointer" *ngIf="talent?.candidatecount >= 10" (click)="navigateToSimilarCandidates(talent?.talentpoolid)"> <span class="text-green-active" ><i class="fa-solid fa-circle f-10 mr-1"></i></span> Available</p>
      <p class="mb-0 d-flex align-items-center" *ngIf="talent?.candidatecount < 10"><span class="text-gray-inactive" ><i class="fa-solid fa-circle f-10 mr-1"></i></span>  Not Available</p>
    </div>
    <div class="col">
      <p class="mb-0" style="color: #B3B3B3;">{{talent?.createdon | date:'dd MMM yyyy'}}</p>
    </div>
    <div class="col-2">
       <span class="ats-cta-btn mr-2 pointer" *ngIf="selectedtalentpools?.length == 0" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Share Talent Pool" matTooltipPosition="above" (click)="triggerTalentpoolSharing(talent)">
        <i class="fa-sharp fa-light fa-share-nodes"></i>
      </span>
      <span class="ats-cta-btn mr-2 pointer" *ngIf="selectedtalentpools?.length == 0" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Delete Talent Pool" matTooltipPosition="above" (click)="deleteTalentpoolConfirmation(talent)">
       <i class="fa-light fa-trash"></i>
      </span>
       <span class="ats-cta-btn pointer" *ngIf="selectedtalentpools?.length == 0" [matTooltipClass]="{ 'big-tooltip': true }" matTooltip="Edit Talent Pool" matTooltipPosition="above" (click)="editTalentpool(talent);">
        <i class="fa-regular fa-pen-to-square"></i>
      </span>
    </div>
   </div>
  </div>
</div>

<div class="new-card d-flex justify-content-center wccard align-items-center"
  [ngClass]="{'sticky-pagination': isScrolled}" *ngIf="talentpools?.length > 0">
  <ngb-pagination [collectionSize]="talentpoolscount" [maxSize]="5" [pageSize]="profilesPerPage" [rotate]="true"
    (pageChange)="setPage($event)" [(page)]="currentPage">
    <ng-template ngbPaginationPrevious> <span></span></ng-template>
    <ng-template ngbPaginationNext>
      <span>Next</span>
    </ng-template>
  </ngb-pagination>

  <div class="page-selection">
    Showing
    <select data-testid="auto-app-talentpool-list-select-1" class="wc-select" name="" id="" [(ngModel)]="profilesPerPage" (change)="updatePagePreference()">
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
    </select>
    Talentpool per page
  </div>
</div>

<!-- <div class="row mb-3px ml-0" *ngIf="talentpools?.length != 0 && !showLoader">
  <div class="col-md-4 pl-0 mb-3" *ngFor="let talent of talentpools">
    <div class="wccard card-data px-3 py-2 d-flex justify-content-between flex-column" [ngClass]="{'border-change': talent.selected, 'border-white':!talent.selected}">
      <div class="">
        <div class="">
          <div class="position-relative w-100 d-flex">
            <label class="wc-checkbox mr-2 mb-0 d-flex">
              <input data-testid="auto-app-talentpool-list-input-4" type="checkbox" id="mycheck" name="mycheck" [checked]="talent.selected"
                [(ngModel)]="talent.selected" (change)="checkIfAllSelected(talent,talent?.selected)" >
              <i class="fas fa-check"></i>
            </label>
            <div class="d-grid align-items-center pointer f-16" style="width: 250px;" (click)="OpenCandidateList(talent);"  [matTooltip]="talent?.name | titlecase" [matTooltipClass]="{ 'red-tooltip': true }"  matTooltipPosition="right">
              <span class="text-truncate font-weight-600 text-capitalize">{{talent?.name }}</span>
              <p class="text-9696 mb-0 mt-1"> -->
                <!-- creator name -->
                <!-- <span class="f-12">
                  <i class="far fa-user"></i><span class="ml-2">{{talent?.firstname}} {{talent?.lastname}}</span>
                </span> -->
                <!-- created date -->
                <!-- <span class="f-8">
                  <i class="fas fa-circle mx-2" style="font-size: 4px;"></i><span class="f-12">{{talent?.createdon | date:'dd MMM yyyy'}}</span>
                </span>
              </p>
            </div>
            <div class="position-absolute tr0 pointer" (click)="OpenCandidateList(talent);">
              <div class="d-flex align-items-center ">
                <i class="fa-light fa-users f-14 text-black"></i> &nbsp;&nbsp; <span
                  class="f-16 font-weight-600">{{talent?.candidatecount}}</span>
              </div>
            </div>
          </div>
          <div class="f-12 text-9696 ml-5 my-2 line-clamp pointer" (click)="OpenCandidateList(talent);" *ngIf="talent?.description">{{talent?.description}}</div>

        </div>
      </div>
      <div>
      <hr class="mb-2 mt-2">
      <div class="row">
        <div class="col d-flex align-items-center float-right justify-content-between pr-0">
          <div class="text-9696 f-12 d-flex align-items-center"> -->
            <!-- suggested candidates chip -->
             <!-- <span class="d-flex align-items-center similar-candidates-chip pointer" [ngStyle]="{ 'visibility': talent?.candidatecount < 10 ? 'hidden' : 'inherit' }" (click)="navigateToSimilarCandidates(talent.talentpoolid)">
               <img class="similar-candidates-chip-icon" src="assets/images/similarCandidates.gif" alt="similar-candidates-gif" height="16px">
              <span class="similar-candidates-chip-text">Similar Candidates</span>
            </span>
          </div>
          <span class="dropdown ats-dropBtn mx-1 ml-2">
            <button data-testid="auto-app-talentpool-list-button-10" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton"
              appDropdownToggle aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="userDropdownButton"> -->
              <!-- Edit talentpool -->
              <!-- <a data-testid="auto-app-talentpool-list-a-7" class="dropdown-item f-14" routerLinkActive="active"
                (click)="editTalentpool(talent)">
                <span>
                  <i class="fa-solid fa-edit mr-1"></i>
                  Edit
                </span>
              </a> -->
              <!-- sharing individual talentpool -->
              <!-- <a data-testid="auto-app-talentpool-list-a-8" class="dropdown-item f-14" routerLinkActive="active"
                (click)="triggerTalentpoolSharing(talent)">
                <span>
                  <i class="fa-solid fa-share-nodes mr-1"></i>
                  Share talentpool
                </span>
              </a>
              <a data-testid="auto-app-talentpool-list-a-9" class="dropdown-item f-14" routerLinkActive="active" (click)="deleteTalentpoolConfirmation(talent)">
                <span>
                  <i class="fa-solid fa-inbox mr-1"></i>
                  Archive
                </span>
              </a>
            </div>
          </span>

        </div>
      </div>
    </div>
    </div>

  </div>
</div> -->
<div class="row" *ngIf="talentpools?.length == 0 && (talentpoolname != null && talentpoolname != '') && !showLoader">
  <div class="col text-center py-3">
    <div class="wccard d-flex align-items-center justify-content-center" style="height: calc(100vh - 214px);">
      <div>

        <div class="row">
          <div class="col">
            <img src="assets/images/talentpool-empty-new.png" class="img-fluid" alt="" srcset="">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="text-484b59 mb-0 my-2 font-weight-600 f-14">
              Say Goodbye to Spreadsheets!
            </p>
            <p class="text-484b59 mb-0 my-2 f-12">
              Manage your CRM and track candidates easily on a cloud-based platform <br/> with AI-powered talent recommendations.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="emptyScreen" *ngIf="showLoader">
  <div class="loader text-center">
    <img style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
  </div>
</div>

<ng-template #noCreditTalentpool class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-talentpool-list-button-11" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-6">
        <div class="col text-center mb-4">
          <img src="../../assets/images/wallet.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col text-center ">
          <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
          <p class="" *ngIf="!isteamMember">You have exhausted your limit for creating talent pieplines</p>
          <p class="" *ngIf="isteamMember">You have exhausted your limit creating talent pieplines, Request more credits
            from your team admin to keep
            going</p>
        </div>
      </div>
      <div class="row" *ngIf="!isteamMember">
        <div class="col-md-10 mx-auto d-flex">
          <!-- <button data-testid="auto-app-talentpool-list-button-12" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
          <button data-testid="auto-app-talentpool-list-button-13" class="btn-trms-medium" (click)="route2pricing()">Upgrade plan</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteTalentpoolmodal>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Archive Talentpool</h5>
    <button data-testid="auto-app-talentpool-list-button-14" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-3">
      <div class="col">
        <p>Are you sure you want to delete this Talentpool?
        <p>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-talentpool-list-button-15" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">No</button>
        <button data-testid="auto-app-talentpool-list-button-16" class="btn-trms-small" (click)="deleteTalentpool()">Yes</button>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
